// Taken from https://stackoverflow.com/a/53914092
export class ClassWatcher {
	private observer: MutationObserver
	private lastClassStateContainsClass: boolean

	/**
	 * Takes an HTMLElement node and a class to watch for, and whenever it's added or removed the
	 * related callbacks are called.
	 *
	 * Useful whenever you want to do an action if a specific class is removed or added
	 *
	 * **Important note: remember to call disconnect when this is no longer used to avoid having orphaned watchers**
	 *
	 * @param targetNode
	 * @param classToWatch
	 * @param classAddedCallback
	 * @param classRemovedCallback
	 */
	constructor(
		readonly targetNode: HTMLElement,
		readonly classToWatch: string,
		readonly classAddedCallback: () => void,
		readonly classRemovedCallback: () => void,
	) {
		this.lastClassStateContainsClass = targetNode.classList.contains(this.classToWatch)
		this.observer = new MutationObserver(this.mutationCallback)
		this.observe()
	}

	observe() {
		this.observer.observe(this.targetNode, { attributes: true })
	}

	disconnect() {
		this.observer.disconnect()
	}

	mutationCallback: MutationCallback = (mutationsList) => {
		for (let mutation of mutationsList) {
			if (mutation.type === "attributes" && mutation.attributeName === "class") {
				const target = mutation.target

				if (target instanceof HTMLElement) {
					let currentClassState = target.classList.contains(this.classToWatch)
					if (this.lastClassStateContainsClass !== currentClassState) {
						this.lastClassStateContainsClass = currentClassState
						if (currentClassState) {
							this.classAddedCallback()
						} else {
							this.classRemovedCallback()
						}
					}
				}
			}
		}
	}
}
